export const loginOptionsKeys = {
    tempCode: "tempCode",
    usernamePassword: "usernamePassword"
};
